import { Injectable } from '@angular/core';
import { Backend } from '../_models/backend';
import JwtResponse = Backend.JwtResponse;

const USER_KEY = 'auth-user-key';
const OAUTH_LOGIN_KEY = 'seos-oauth-login';
const GUEST_LOGIN_KEY = 'seos-guest-login';
const PAIRED_LOGIN_TOKEN_KEY = 'paired-login-token-key';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {

  constructor() {
  }

  public setUser(user: JwtResponse): void {
    window.sessionStorage.removeItem(USER_KEY);
    window.sessionStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  public getUser(): JwtResponse | null {
    const user = sessionStorage.getItem(USER_KEY);

    if (user != null) {
      return JSON.parse(user);
    }
    return null;
  }

  public setPairedLoginToken(pairedLoginToken: string): void {
    window.localStorage.removeItem(PAIRED_LOGIN_TOKEN_KEY);
    window.localStorage.setItem(PAIRED_LOGIN_TOKEN_KEY, pairedLoginToken);
  }

  public getPairedLoginToken(): string | null {
    const pairedLoginToken = localStorage.getItem(PAIRED_LOGIN_TOKEN_KEY);

    if (pairedLoginToken != null) {
      return pairedLoginToken;
    }
    return null;
  }

  public saveOauthLogin(oauthLogin: boolean | null | undefined): void {
    window.sessionStorage.removeItem(OAUTH_LOGIN_KEY);
    window.sessionStorage.setItem(OAUTH_LOGIN_KEY, JSON.stringify(oauthLogin));
  }

  public getOauthLogin(): boolean {
    const isOauthLogin = sessionStorage.getItem(OAUTH_LOGIN_KEY);

    if (isOauthLogin != null) {
      return JSON.parse(isOauthLogin);
    }
    return false;
  }

  public saveGuestLogin(guestLogin: boolean): void {
    window.sessionStorage.removeItem(GUEST_LOGIN_KEY);
    window.sessionStorage.setItem(GUEST_LOGIN_KEY, JSON.stringify(guestLogin));
  }

  public getGuestLogin(): boolean {
    const isGuestLogin = sessionStorage.getItem(GUEST_LOGIN_KEY);

    if (isGuestLogin != null) {
      return JSON.parse(isGuestLogin);
    }
    return false;
  }

  public clearGuestLogin(): void {
    window.sessionStorage.removeItem(GUEST_LOGIN_KEY);
  }

  clearUser(): void {
    window.sessionStorage.removeItem(USER_KEY);
  }

  clearPairedLoginToken(): void {
    window.localStorage.removeItem(PAIRED_LOGIN_TOKEN_KEY);
    window.sessionStorage.removeItem(USER_KEY);
  }

  clearStorage(): void {
    window.sessionStorage.clear();
  }
}
